import { Grid, Typography, Stack } from '@mui/material';

import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import Banner from 'common/components/Banner/Banner';
import TabBar from 'common/components/TabBar/TabBar';
import {
	GRID_VIEW_PAGE_SIZE,
	MODULES,
	TABLE_VIEW_PAGE_SIZE,
} from 'common/constants';
import { REGULATION_TAB_VALUES } from 'common/constants/RegulationInventoryConstants';
import { RootState } from 'common/store/AppStore';
import { toSentenceCase } from 'common/utils/utilFunctions';

import useTableQuery from 'hooks/useTableQuery';

import BuildWorkFlow from './RegInvCards/BuildWorkFlow/BuildWorkFlow';
import CurrentInventory from './RegInvCards/CurrentInventory/CurrentInventory';

import styles from './RegInvCardsLandingPage.module.scss';

const { CURRENT_INVENTORY, BUILD_WORKFLOW, HORIZON_SCANNING } =
	REGULATION_TAB_VALUES;

const { REQUIREMENT_INVENTORY } = MODULES;

const { GRID_SIZE_10 } = GRID_VIEW_PAGE_SIZE;

const { TABLE_SIZE_12 } = TABLE_VIEW_PAGE_SIZE;

const RegInvCardsLandingPage = () => {
	const regInvSelectedTab = useSelector(
		(state: RootState) => state.regulationInventory.regInvLandingSelectedTab,
	);

	const selectedTabIndex = regInvSelectedTab === CURRENT_INVENTORY ? 0 : 1;

	const createTabDetail = (str: string, isDisable?: boolean) => ({
		name: str.charAt(0).toUpperCase() + str.slice(1),
		count: 0,
		disabled: isDisable,
	});

	const tabDetails: any[] = [
		createTabDetail(CURRENT_INVENTORY),
		createTabDetail(BUILD_WORKFLOW),
		createTabDetail(HORIZON_SCANNING, true),
	];

	const tabs = [
		{
			id: 1,
			children: <CurrentInventory key="CurrentInventory" />,
		},
		{
			id: 2,
			children: <BuildWorkFlow key="BuildWorkFlow" />,
		},
		{
			id: 3,
			children: <BuildWorkFlow key="HorizonScaling" />,
		},
	];

	const { updateTableQuery } = useTableQuery({
		id: 'AllRegTable',
		defaultPageSize: TABLE_SIZE_12,
	});

	useEffect(() => {
		const pageObj = {
			pageSize: GRID_SIZE_10,
			pageNumber: 0,
		};
		updateTableQuery(pageObj);
	}, []);
	return (
		<Grid>
			<div>
				<Banner>
					<Stack p={2} className={styles['regulation-header-wrapper']}>
						<Typography
							className={
								styles['regulation-inventory-landingpage-banner-heading']
							}
						>
							{toSentenceCase(REQUIREMENT_INVENTORY)}
						</Typography>
					</Stack>
				</Banner>
				<TabBar
					details={tabDetails}
					components={tabs}
					showCount={false}
					showButton={false}
					activeTab={selectedTabIndex}
				/>
			</div>
		</Grid>
	);
};

export default RegInvCardsLandingPage;
